<template>
  <div
    :key="childTest.id"
    class="w-full h-full flex flex-col bg-white rounded-lg overflow-hidden shadow-lg md:shadow-card pb-2"
  >
    <div class="bg-terace-pool px-5 py-6 flex flex-col">
      <div class="w-full flex justify-between items-center text-[19px] leading-tight font-bold">
        <span class="pr-2">{{ $t("testDetail.childTestTitle", { title: childTest.title }) }}</span>
        <span class="whitespace-nowrap">+{{ $formatCurrency(childTest.price) }}</span>
      </div>
    </div>

    <div class="w-full flex items-start px-5 py-6 pb-1 mb-4 filter">
      <input
        type="checkbox"
        :id="checkboxId"
        class="absolute opacity-0 w-5 h-5 peer cursor-pointer"
        :value="childTest.id"
        :checked="isDependentChecked(childTest)"
        @change="toggleDependent(childTest, $event)"
      />

      <ProductCheckbox class="mt-[1px]" />

      <label :for="checkboxId" class="w-full select-none text-[14px] cursor-pointer px-2 peer-checked:font-bold">
        {{ childTest.summary }}
      </label>
    </div>
  </div>
</template>

<script setup>
import { useProductStore } from "@/stores/filter";
import { useCheckoutStore } from "~/stores/checkout";

const checkoutStore = useCheckoutStore();
const filterStore = useProductStore();

const props = defineProps({
  childTest: {
    type: Object,
    required: true,
  },
});

const checkboxId = `${props.childTest.slug}-${Math.random().toString(36).substring(2, 9)}`;

const isDependentChecked = (child) => checkoutStore.dependentTests.some((dep) => dep.id === child.id);

const toggleDependent = (child, event) => {
  if (event.target.checked) {
    checkoutStore.addDependentTest(child);
  } else {
    checkoutStore.removeDependentTest(child);
  }
};
</script>
